var map = {
	"./3do.svg": 7949,
	"./android.svg": 2747,
	"./atari.svg": 3094,
	"./commodore-amiga.svg": 1198,
	"./ios.svg": 9142,
	"./linux.svg": 5627,
	"./mac.svg": 7728,
	"./neo-geo.svg": 2138,
	"./nintendo.svg": 8513,
	"./pc.svg": 7047,
	"./playstation.svg": 273,
	"./sega.svg": 8522,
	"./web.svg": 1717,
	"./xbox.svg": 5764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2616;